<template>
  <div class="w-full h-full">
    <div class="text-center bg-white rounded-lg shadow-xl content">
      <div class="flex justify-center p-3 md:p-4" style="background-color: #3a3a3a">
        <img class="hy3d-logo" src="../assets/images/logo.png" />
      </div>

      <div class="px-7 pt-7 mb-5 md:px-12 md:pt-12 md:pb-3">
        <div class="text-4xl font-bold md:text-5xl" style="color: #666">
          견적서를 등록 했습니다.
        </div>
        <div class="mt-2" style="color: #aaa">전문가가 확인 후 바로 연락드리겠습니다.</div>

        <ul class="px-3 mt-12 md:px-5">
          <li class="flex justify-between">
            <span class="text-desc">출력 비용</span
            ><span class="text-xl font-semibold"
              >{{ numberToComma(estimate.buildCost ? estimate.buildCost : 0) }} 원</span
            >
          </li>
          <li class="flex justify-between mt-3">
            <span class="text-desc">배송 비용</span
            ><span class="text-xl font-semibold">{{ shippingCost }} 원</span>
          </li>
          <li class="flex justify-between mt-3">
            <span class="text-desc">동시제작 할인비용</span
            ><span class="text-xl font-semibold text-danger">{{ discountCost }} 원</span>
          </li>
          <li>
            <div class="mt-5 mb-5 border-t border-line"></div>
          </li>
          <li class="flex justify-between">
            <span class="text-desc">부가세 V.A.T (예상)</span
            ><span class="text-xl font-semibold">{{ vat }} 원</span>
          </li>
          <li class="flex justify-between mt-3">
            <span class="font-semibold">총 비용 (예상)</span
            ><span class="text-xl font-semibold">{{ totalCost }} 원</span>
          </li>
        </ul>

        <div
          class="p-4 mt-12 text-xl font-bold rounded-lg md:p-5 md:text-2xl"
          style="background-color: #515151; color: #e7e7e7"
        >
          No. {{ estimate.id }}
        </div>

        <div class="flex justify-between mt-8 w-full">
          <button class="cs-btn cs-btn-default cs-pd-btn" @click="onPrint">
            <div class="flex items-center">
              <i class="flex text-xl fi fi-rs-print"></i><span class="ml-2">견적서 출력</span>
            </div>
          </button>
          <button class="cs-btn cs-btn-clear cs-pd-btn" @click="onBack">뒤로가기</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed} from "vue";
import {useRouter} from "vue-router";
import {storeToRefs} from "pinia";
import {EstimateStore} from "../store/estimate-store";
import {ModelStore} from "../store/model-store";
import {numberToComma} from "../js/utils";

const router = useRouter();
const {estimate} = storeToRefs(EstimateStore());
const {models} = storeToRefs(ModelStore());

const shippingCost = computed(() => {
  return numberToComma(models.value.length ? estimate.value.shippingCost : 0);
});
const vat = computed(() => {
  return numberToComma(estimate.value.totalCost ? Math.floor(estimate.value.totalCost * 0.1) : 0);
});
const discountCost = computed(() => {
  return estimate.value.discountCost ? numberToComma(estimate.value.discountCost * -1) : 0;
});
const totalCost = computed(() => {
  const vatValue = Math.floor(estimate.value.totalCost * 0.1);
  return models.value.length ? numberToComma(estimate.value.totalCost + vatValue) : 0;
});

const onPrint = () => {
  window.open(`${process.env.VUE_APP_BASE_WEB_URL}/estimate/print?estimateId=${estimate.value.id}`, "_blank");
};

const onBack = () => {
  window.location.href = process.env.VUE_APP_BASE_WEB_URL;
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.content {
  @apply overflow-hidden w-4/5 md:w-fit;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.hy3d-logo {
  @apply w-36 md:w-40;
}
</style>
